import { safeDefine } from "../../registration/safe-define.js";
import "../ui/container.js";
import { BackgroundVideoSkinElement } from "../../presets/background/skin.js";
//#region src/define/background/skin.ts
safeDefine(BackgroundVideoSkinElement);
//#endregion

//# sourceMappingURL=skin.js.map